/**
 * ShortcutBadge Component
 *
 * @module shared/components/ShortcutBadge
 *
 * Small keyboard shortcut hint (e.g. "Alt+H") rendered as a `kbd` element.
 */

import Box from '@mui/material/Box';

// ============================================================================
// Types
// ============================================================================

export interface ShortcutBadgeProps {
  /** Shortcut text to display, e.g. "Alt+H". */
  label: string;
}

// ============================================================================
// Component
// ============================================================================

export function ShortcutBadge({ label }: ShortcutBadgeProps) {
  return (
    <Box
      component="kbd"
      sx={{
        display: 'inline-block',
        px: 0.6,
        py: 0.1,
        border: 1,
        borderColor: 'divider',
        borderRadius: 0.5,
        bgcolor: 'action.hover',
        color: 'text.secondary',
        fontFamily: 'monospace',
        fontSize: '0.625rem',
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
}
